import {
	BillingDelinquencyTier,
	ConfiningBillingDelinquencyTier,
} from '~constants/billing/delinquency';
import { LDFlags } from '~types/featureFlags';

/** Partial: an unset flag comes back from LaunchDarkly as undefined. */
type BillingDelinquencyFlags = Partial<
	Pick<
		LDFlags,
		| 'billingOverduePaymentBanner'
		| 'billingAccountSuspendedModal'
		| 'billingAccountSuspended90Days'
	>
>;

/**
 * The flags are independent lists, so a business can be in several: most severe wins.
 * None means no treatment, not that the account is healthy.
 */
export const getBillingDelinquencyTier = (
	flags: BillingDelinquencyFlags,
): BillingDelinquencyTier | null => {
	if (flags.billingAccountSuspended90Days) {
		return BillingDelinquencyTier.LOCKED;
	}
	if (flags.billingAccountSuspendedModal) {
		return BillingDelinquencyTier.SUSPENDED;
	}
	if (flags.billingOverduePaymentBanner) {
		return BillingDelinquencyTier.OVERDUE;
	}
	return null;
};

export const isConfiningTier = (
	tier: BillingDelinquencyTier | null,
): tier is ConfiningBillingDelinquencyTier =>
	tier === BillingDelinquencyTier.SUSPENDED || tier === BillingDelinquencyTier.LOCKED;
